"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderItems = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const constants_1 = require("../../constants");
require("../../core");
const renderInlineText_1 = require("./renderInlineText");
function renderItems(items, itemRenderer, getIcon) {
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return renderInlineText_1.renderInlineText(constants_1.EMPTY_TEXT.dash);
    }
    return (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, gap: components_1.STACK_GAP.xxs }, items.map((item, idx) => (react_1.default.createElement(components_1.StackView, { key: idx, direction: components_1.STACK_DIRECTION.row, gap: components_1.STACK_GAP.xs },
        getIcon ? react_1.default.createElement(components_1.Icon, { src: getIcon(item) }) : null,
        itemRenderer(item))))));
}
exports.renderItems = renderItems;
//# sourceMappingURL=renderItems.js.map